import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()

export class DataService {
  // Observable string sources
  private dataSource = new BehaviorSubject<any>({status: false});

  // Observable string streams
  data$ = this.dataSource.asObservable();

  constructor() { }

  changeData(data) {
    this.dataSource.next(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data.service.ts